import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const UpdateResidentNoteRequestDtoSchema = z.object({
  id: z.number(),
  noteId: z.number(),
  noteText: z.string(),
});

const UpdateResidentNoteResponseDtoSchema = z.object({
  id: z.number(),
  noteText: z.string(),
  takenBy: z.string(),
  creationDate: z.coerce.date(),
  takenById: z.number(),
});

export type UpdateResidentNoteRequestDto = z.infer<
  typeof UpdateResidentNoteRequestDtoSchema
>;
export type UpdateResidentNoteResponseDto = z.infer<
  typeof UpdateResidentNoteResponseDtoSchema
>;

export const updateResidentNote = (
  dto: UpdateResidentNoteRequestDto,
  config?: AxiosRequestConfig<UpdateResidentNoteRequestDto>
) => {
  const { id, noteId, ...data } = UpdateResidentNoteRequestDtoSchema.parse(dto);

  return api
    .patch(`residents/${id}/notes/${noteId}`, data, config)
    .then(responseContract(UpdateResidentNoteResponseDtoSchema));
};
